import { getSaleInvoiceTotal } from 'services/saleInvoiceContract';

export const recoverableWalkInSale = invoice => {
  if (!Number.isInteger(Number(invoice?.id)) || Number(invoice.id) <= 0
    || invoice.status !== 'Pending' || !Array.isArray(invoice.cart) || !invoice.cart.length
    || !Array.isArray(invoice.appointments) || invoice.appointments.length
    || !Array.isArray(invoice.payments) || invoice.payments.length
    || Number(invoice.paid?.amount_minor ?? 0) !== 0 || getSaleInvoiceTotal(invoice) <= 0) return null;
  return { ...invoice, payment_state: 'payment_required' };
};
